import { render } from "./PreviewUploadZone.vue?vue&type=template&id=5caba82c&scoped=true"
import script from "./PreviewUploadZone.vue?vue&type=script&lang=js"
export * from "./PreviewUploadZone.vue?vue&type=script&lang=js"

import "./PreviewUploadZone.vue?vue&type=style&index=0&id=5caba82c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caba82c"]])

export default __exports__